<template>
  <div class="contractAward">
    <el-card>
      <el-form ref="filter" :model="filter" inline size="small" label-width="100px">
        <el-form-item label="用户手机号" prop="phone">
          <el-input v-model="filter.phone" placeholder="用户手机号" clearable />
        </el-form-item>
        <el-form-item label="合同编号" prop="contractNumber">
          <el-input v-model="filter.contractNumber" placeholder="合同编号" clearable />
        </el-form-item>
        <el-form-item label="订单号" prop="orderNumber">
          <el-input v-model="filter.orderNumber" placeholder="订单号" clearable />
        </el-form-item>
        <el-form-item label="用户姓名" prop="name">
          <el-input v-model="filter.name" placeholder="用户姓名" clearable />
        </el-form-item>
        <el-form-item label="证件号码" prop="idCard">
          <el-input v-model="filter.idCard" placeholder="请输入证件号码" clearable />
        </el-form-item>
        <!-- <el-form-item label="签约状态">
          <el-select v-model="filter.courseType" placeholder="签约状态" clearable>
            <el-option label="已签约" :value="1" />
            <el-option label="未签约" :value="2" />
          </el-select>
        </el-form-item> -->
        <el-form-item label="支付时间" prop="queryTime">
          <my-datePicker
            width="290px"
            :scopeDate="filter.queryTime"
            @receiveMyDate="queryTimeReceiveMyDate"
          />
        </el-form-item>
        <el-form-item label="所属租户" prop="companyId">
          <el-select v-model="filter.companyId" placeholder="所属租户" clearable>
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in companyList" :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item label-width="120px" label=" ">
          <el-button type="primary" size="small" @click="search">搜索</el-button>
          <el-button type="" size="small" @click="reset('filter')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <br>
    <el-table :data="tableData" border>
      <el-table-column align="center" label="姓名" prop="name" min-width="120px" :formatter="fliteRData" />
      <el-table-column align="center" label="所属租户" prop="companyName" min-width="150px" :formatter="fliteRData" />
      <el-table-column align="center" label="合同名称" prop="contractName" min-width="150px" :formatter="fliteRData" />
      <el-table-column align="center" label="用户手机号" prop="phone" min-width="120px" :formatter="fliteRData">
        <template slot-scope="{ row, $index }">
          <el-button type="text" @click="handleViewPhone(row, $index)">{{ row.phone || '--' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户昵称" prop="nickname" min-width="150px" :formatter="fliteRData" />
      <el-table-column align="center" label="合同编号" prop="contractNumber" min-width="180px" :formatter="fliteRData" />
      <el-table-column align="center" label="价格" prop="signPrice" min-width="120px" :formatter="fliteRData" />
      <el-table-column align="center" label="证件类型" prop="type" min-width="120px">
        <template v-slot="{ row }">
          <el-tag type="info">{{zjtypeData[row.type]}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="证件号码" prop="idCard" min-width="180px" :formatter="fliteRData" />
      <el-table-column align="center" label="订单号" prop="orderNumber" min-width="180px" :formatter="fliteRData" />
      <el-table-column align="center" label="支付时间" prop="payTime" min-width="180px" :formatter="fliteRData" />
      <!-- <el-table-column align="center" label="签约状态" prop="sortNum" min-width="120px" /> -->
      <el-table-column align="center" label="是否签约" prop="sign" min-width="120px">
        <template v-slot="{ row }">
          <el-tag type="success" v-if="row.sign == 2">已签字</el-tag>
          <el-tag type="info" v-else>未签字</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间" prop="insertDate" min-width="180px" />
      <!-- <el-table-column align="center" label="审核状态" prop="sortNum" min-width="120px" /> -->
      <el-table-column align="center" label="是否提交发票信息" prop="invoiceApplyStatus" min-width="150px">
        <template v-slot="{ row }">
          <el-tag type="success" v-if="row.invoiceApplyStatus == 2">是</el-tag>
          <el-tag type="info" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" prop="sortNum" min-width="200px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="del(row)">删除</el-button>
          <el-button type="text" @click="detail(row)">查看</el-button>
          <el-button v-if="$hasAuthority('app1_award_edit') && row.sign === 2" type="text" @click="edit(row)">修改合同信息</el-button>
        </template>
      </el-table-column>
    </el-table>
    <br>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <!-- 修改合同信息 -->
    <el-dialog title="修改合同信息" :visible.sync="modalShow" width="540px" :before-close="handleCloseModal">
      <el-form ref="modalFormEl" :model="modalForm" :rules="rules" size="small" label-width="160px">
        <el-form-item label="乙方（学员）姓名：" prop="name">
          <el-input v-model="modalForm.name" maxlength="100" placeholder="请输入乙方（学员）姓名" clearable />
        </el-form-item>
        <el-form-item label="证件号码：" prop="idCard">
          <el-input v-model="modalForm.idCard" maxlength="100" placeholder="请输入证件号码" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="handleCloseModal">取消</el-button>
        <el-button type="primary" size="small" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tableMoudel from "@/libs/mixins/table"
import myDatePicker from "@/components/myDatePicker.vue";
import { contractSignList, delContractSign, getPrivateImgUrl } from "@/api/product/base"
import { getAppUserInfo } from "@/api/common";
import { getSelectCompanyList, updateContractById } from "@/api/orderAdmin/orderList";
const zjtypeData = {
  1: "身份证",
  2: '护照',
  3: "军官证",
  4: "港澳台证件",
  'undefined': "--"
}

export default {
  mixins: [tableMoudel],
  components: {
    myDatePicker
  },
  data () {
    return {
      companyList: [],
      zjtypeData,
      filter: {
        name: null,
        phone: null,
        contractNumber: null,
        orderNumber: null,
        idCard: null,
        queryTime: [],
        companyId: null,
      },
      companyId: "",
      modalShow: false,
      modalForm: {
        contractSignId: '',
        name: '',
        idCard: ''
      },
      rules: {
        name: [
          { required: true, message: "请输入乙方（学员）姓名", trigger: "blur" }
        ],
        idCard: [
          { required: true, message: "请输入证件号码", trigger: "blur" }
        ]
      }
    }
  },
  created () {
    this.getCompanyList()
    this.getData()
  },
  methods: {
    // 支付时间
    queryTimeReceiveMyDate(payload) {
      this.filter.queryTime = payload;
    },
    // 租户列表
    getCompanyList(){
      getSelectCompanyList().then((res) => {
        if(res.code === 0){
          this.companyList = res.data || [];
          this.companyId = res.data[0]?.id;
          this.filter.companyId = this.companyId;
          this.getData()
        }
      })
    },
    async getData () {

      const params = {
        ...this.pageInfo,
        ...this.filter
      }
      if(params.queryTime.length > 0){
        params.queryStartTime = params.queryTime[0] + " 00:00:00";
        params.queryEndTime = params.queryTime[1] + " 23:59:59";
      }
      delete params.queryTime;
      const res = await contractSignList(params)
      const { records, total } = res.data
      this.total = Number(total)
      this.tableData = records
    },
    del (item) {
      this.$confirm(`确定要删除此数据吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await delContractSign({ id: item.id })
        if (res.code !== 0) {
          this.$message.error(res.message)
          return
        }
        this.$message.success('操作成功！')
      })
    },
    async detail (data) {
      if (data.sign !== 2) {
        return this.$message.warning('该协议暂未签字, 不可以查看')
      }
      const res = await getPrivateImgUrl(data.signImgPath)
      const { code, message } = res
      if(code!== 0) {
        this.$message.error(message)
        return
      }
      window.open(res.data, '_blank')
    },
    edit ({ id }) {
      this.modalForm.contractSignId = id
      this.modalShow = true
    },
    submit () {
      this.$refs.modalFormEl.validate(async (valid) => {
        if (!valid) return
        const res = await updateContractById(this.modalForm)
        if (res.code !== 0) {
          this.$message.error(res.message)
          return
        }
        this.handleCloseModal()
        this.$message.success('修改合同信息成功！')
        this.getData()
      })
    },
    reset(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
        this.pageInfo.page = 1;
        this.filter.companyId = this.companyId;
        this.getData('init')
      })
    },
    handleCloseModal () {
      this.$refs.modalFormEl.resetFields()
      this.modalForm = this.$options.data().modalForm
      this.modalShow = false
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.userId }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.tableData.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    }
  }
}
</script>

<style>
</style>
